export default "__VITE_ASSET__BLMK1n6B__"